export default [
	{
		"id": "1",
		"uf": "AC",
		"name": "Acre",
		"ibgeId": "12",
	},
	{
		"id": "2",
		"uf": "AL",
		"name": "Alagoas",
		"ibgeId": "27",
	},
	{
		"id": "3",
		"uf": "AM",
		"name": "Amazonas",
		"ibgeId": "13",
	},
	{
		"id": "4",
		"uf": "AP",
		"name": "Amapá",
		"ibgeId": "16",
	},
	{
		"id": "5",
		"uf": "BA",
		"name": "Bahia",
		"ibgeId": "29",
	},
	{
		"id": "6",
		"uf": "CE",
		"name": "Ceará",
		"ibgeId": "23",
	},
	{
		"id": "7",
		"uf": "DF",
		"name": "Distrito Federal",
		"ibgeId": "53",
	},
	{
		"id": "8",
		"uf": "ES",
		"name": "Espírito Santo",
		"ibgeId": "32",
		"closureCrc": true,
	},
	{
		"id": "9",
		"uf": "GO",
		"name": "Goiás",
		"ibgeId": "52",
	},
	{
		"id": "10",
		"uf": "MA",
		"name": "Maranhão",
		"ibgeId": "21",
	},
	{
		"id": "11",
		"uf": "MG",
		"name": "Minas Gerais",
		"ibgeId": "31",
	},
	{
		"id": "12",
		"uf": "MS",
		"name": "Mato Grosso do Sul",
		"ibgeId": "50",
	},
	{
		"id": "13",
		"uf": "MT",
		"name": "Mato Grosso",
		"ibgeId": "51",
	},
	{
		"id": "14",
		"uf": "PA",
		"name": "Pará",
		"ibgeId": "15",
	},
	{
		"id": "15",
		"uf": "PB",
		"name": "Paraíba",
		"ibgeId": "25",
	},
	{
		"id": "16",
		"uf": "PE",
		"name": "Pernambuco",
		"ibgeId": "26",
	},
	{
		"id": "17",
		"uf": "PI",
		"name": "Piauí",
		"ibgeId": "22",
	},
	{
		"id": "18",
		"uf": "PR",
		"name": "Paraná",
		"ibgeId": "41",
	},
	{
		"id": "19",
		"uf": "RJ",
		"name": "Rio de Janeiro",
		"ibgeId": "33",
	},
	{
		"id": "20",
		"uf": "RN",
		"name": "Rio Grande do Norte",
		"ibgeId": "24",
	},
	{
		"id": "21",
		"uf": "RO",
		"name": "Rondônia",
		"ibgeId": "11",
	},
	{
		"id": "22",
		"uf": "RR",
		"name": "Roraima",
		"ibgeId": "14",
	},
	{
		"id": "23",
		"uf": "RS",
		"name": "Rio Grande do Sul",
		"ibgeId": "43",
	},
	{
		"id": "24",
		"uf": "SC",
		"name": "Santa Catarina",
		"ibgeId": "42",
	},
	{
		"id": "25",
		"uf": "SE",
		"name": "Sergipe",
		"ibgeId": "28",
	},
	{
		"id": "26",
		"uf": "SP",
		"name": "São Paulo",
		"ibgeId": "35",
		"closureCrc": true,
		"manualSearches": true,
	},
	{
		"id": "27",
		"uf": "TO",
		"name": "Tocantins",
		"ibgeId": "17",
	},
	{
		"id": "99",
		"uf": "EX",
		"name": "Estrangeiro",
		"ibgeId": "99",
	}
]
